// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f9d3a7b1","455":"f421afce"}[chunkId] + ".chunk.js";
};